import React, { useState } from "react";
import { useSelector } from "react-redux";
import { DatalistField, FormDateField, FormSelectField } from "./FormComponents";
import { EXPIRY_DATE_BY_MONTH } from "../../../../../constants";

const ReferralFormComponent = ({ referral: { startDate, id, expiredDate, expiredDateByMonth }, handleValueChange }) => {
  const practitioners = useSelector(({ app: { practitioners } }) => practitioners);
  const [specialistsOptions, setSpecialistsOptions] = useState([]);

  const handlePractitionerSelect = (selectedItem) => {
    const practitionerId = practitioners.find(({ firstName, lastName }) => {
      const fullName = `${firstName} ${lastName}`;
      return selectedItem === fullName;
    })?.practitionerId;

    handleValueChange("id")(practitionerId);
  };

  const handlePractitionerValueChange = (value) => {
    const options = practitioners.reduce((res, { firstName, lastName }) => {
      const fullName = `${firstName} ${lastName}`;
      if (fullName.toLowerCase().includes(value?.toLowerCase())) {
        return [...res, fullName];
      }

      return [...res];
    }, []);

    setSpecialistsOptions(options);
  };

  const handleExpiryDateByMonthChange = (value) => {
    handleValueChange("expiredDateByMonth")(value);
    handleValueChange("expiredDate")("");
  };

  const handleExpiryDateChange = (value) => {
    handleValueChange("expiredDate")(value);
    handleValueChange("expiredDateByMonth")("");
  };

  return (
    <>
      <p className="menu-label">REFERRAL</p>
      <div className="columns">
        <DatalistField
          id="practitioner"
          className="column is-one-quarter"
          required
          label="Practitioner"
          defaultValue={id}
          options={specialistsOptions}
          onSelect={handlePractitionerSelect}
          onValueChange={handlePractitionerValueChange}
        />
        <FormDateField
          className="column is-one-quarter"
          required
          label="Referral Start Date"
          value={startDate}
          onValueChange={handleValueChange("startDate")}
        />
        <FormDateField
          className="column is-one-quarter"
          required
          label="Referral Expiry Date"
          value={expiredDate}
          onValueChange={handleExpiryDateChange}
        />
        <FormSelectField
          className="column is-one-quarter"
          required
          label="Expiry Date By Month"
          onValueChange={handleExpiryDateByMonthChange}
          options={EXPIRY_DATE_BY_MONTH}
          value={expiredDateByMonth}
        />
      </div>
    </>
  );
};

export default ReferralFormComponent;
